/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Spec_LicenseInputs */

const en_fc_home_spec_license = /** @type {(inputs: Fc_Home_Spec_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License`)
};

/**
* | output |
* | --- |
* | "License" |
*
* @param {Fc_Home_Spec_LicenseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_spec_license = /** @type {((inputs?: Fc_Home_Spec_LicenseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Spec_LicenseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_spec_license(inputs)
});
export { fc_home_spec_license as "fc.home.spec.license" }